// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CompanySizeSchema = z.enum(['SMALL','MID','LARGE','ENTERPRISE'] as const);

export type CompanySizeType = `${z.infer<typeof CompanySizeSchema>}`

export default CompanySizeSchema;
